import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: 'Will I actually have time for this?',
    answer: 'Absolutely. The protocol is designed in 5 to 10-minute "Micro-Sprints." It\'s made for moms who always have a baby in their arms.'
  }, {
    question: "Does it work if it's been more than 6 months since I gave birth?",
    answer: "Yes. Postpartum can biologically last for years if inflammation and nutrient deficiencies aren't addressed. It's never too late to start."
  }, {
    question: 'Do I need to buy expensive supplements?',
    answer: 'No. We recommend accessible, natural options you can find at any local health store or pharmacy.'
  }];
  return <section className="py-20 px-4 bg-white" data-id="element-21">
      <div className="max-w-3xl mx-auto" data-id="element-22">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-brown mb-12" data-id="element-23">
          Frequently Asked Questions
        </h2>

        <div className="space-y-4" data-id="element-24">
          {faqs.map((faq, index) => <div key={index} className={`border rounded-2xl overflow-hidden transition-colors duration-300 ${openIndex === index ? 'border-sage bg-sage/5' : 'border-cream-dark bg-white'}`} data-id="element-25">
              <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} aria-expanded={openIndex === index} data-id="element-26">
                <span className="font-heading font-bold text-lg text-brown pr-4" data-id="element-27">
                  {faq.question}
                </span>
                {openIndex === index ? <ChevronUp className="w-5 h-5 text-sage flex-shrink-0" data-id="element-28" /> : <ChevronDown className="w-5 h-5 text-brown-light flex-shrink-0" data-id="element-29" />}
              </button>

              <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-40 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-30">
                <p className="text-brown-light font-body leading-relaxed" data-id="element-31">
                  {faq.answer}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}